import React, { useEffect } from "react";
import styles from "./Footer.module.scss";
import Container from "react-bootstrap/Container";
import SubscribeNow from "./SubscribeNow/SubscribeNow";
import Recognition from "./Recognition/Recognition";
import FooterUtilityBar from "./FooterUtilityBar/FooterUtilityBar";
import FooterMain from "./FooterMain/FooterMain";
import SiteMap from "./SiteMap/SiteMap";

const Footer: React.FC = (props: any) => {
  // ICEF Badge script loader
  useEffect(() => {
    // Remove any existing script to ensure clean state
    const existingScript = document.querySelector('script[src*="iasbadgeid.js"]');
    if (existingScript) {
      existingScript.remove();
    }

    // Clear the badge container
    const badgeSpan = document.getElementById("iasBadge");
    if (badgeSpan) {
      badgeSpan.innerHTML = "";
    }

    // Create and inject fresh script
    const script = document.createElement("script");
    script.src = "https://www-cdn.icef.com/scripts/iasbadgeid.js";
    script.async = true;
    script.defer = true;
    script.crossOrigin = "anonymous";

    document.body.appendChild(script);

    // Cleanup function
    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);

  return (
    <>
      <div id="footer-svg" className={styles.footersvgimg}>
        <Container>
          <div className={styles.footerImg}>
            <img src="/icons/three_dotted_lines.svg" alt="decorative lines" width={100} height={191} />
          </div>
        </Container>
      </div>
      <footer id="about-footer" className={styles.footerMain}>
        <SubscribeNow />

        <FooterMain footerData={props?.footerData} />

        <Recognition footerData={props?.footerData} />

        <SiteMap footerData={props?.footerData} />

        <FooterUtilityBar footerData={props?.footerData} />
      </footer>
    </>
  );
};

export default Footer;
